import React from 'react'
import styled from 'styled-components'

const Contact = ({isModal = false}) => {
    return (
        <ContactStyle id={"contact-details"} isModal={isModal}>
            <MailWrapper>
                <Mail>
                    <H3>We would love<br/> to hear from you</H3>
                    <P>Send us an email and our team will get back to you.</P>
                    <LinkMail><a
                        href="mailto:info@medadtechnology.com"><span>info@medadtechnology.com</span></a></LinkMail>
                
                </Mail>
            </MailWrapper>
        </ContactStyle>
    )
}

export default Contact

const ContactStyle = styled.div`
  //padding-top: 9.2rem;
  //padding-left: 12rem;
  //padding-right: 12rem;
  //padding-bottom: 9.2rem;
  padding-top: ${({isModal}) => isModal ? '5.6rem' : '9.2rem'};
  padding-bottom: ${({isModal}) => isModal ? '5.6rem' : '9.2rem'};
  padding-right: ${({isModal}) => isModal ? '9.4rem' : '12rem'};
  padding-left: ${({isModal}) => isModal ? '6rem' : '12rem'};

  display: flex;
  justify-content: space-between;
  gap: ${({isModal}) => isModal ? '55px' : 'none'};
  align-items: flex-start;
  @media ${({theme}) => theme.breakpoints.mobile} {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    padding-bottom: 3.5rem;

    padding-top: ${({isModal}) => isModal ? '40px' : '90px'};
    padding-bottom: ${({isModal}) => isModal ? '40px' : '35px'};
    padding-right: ${({isModal}) => isModal ? '14px' : '24px'};
    padding-left: ${({isModal}) => isModal ? '14px' : '24px'};

    gap: ${({isModal}) => isModal ? '30px' : 'none'};

    flex-direction: column;
    justify-content: center;
    align-items: center;
    form {
      width: 100%;
    }
  }
  @media ${({theme}) => theme.breakpoints.small_height} {
    padding: 9.2rem 9.4rem 9.2rem 6rem;
    gap: 22rem;
  }
`

const MailWrapper = styled.div`
  flex: 1;
  @media ${({theme}) => theme.breakpoints.mobile} {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
`

const Mail = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`

const H3 = styled.h3`
  max-width: 34.9rem;
  font-family: Sequel75;
  font-size: 3.2rem;
  line-height: 5.4rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    font-size: 2rem;
    line-height: 2.8rem;
    br {
      display: none;
    }
  }
`

const P = styled.p`
  margin-top: 2.6rem;
  max-width: 34.2rem;
  font-family: Sequel45;
  font-weight: normal;
  font-size: 2rem;
  line-height: 2.7rem;
`

const LinkMail = styled.div`
  font-family: Sequel45;
  font-size: 2rem;
  line-height: 2.6rem;
  margin-top: .7rem;

  span {
    color: #3B869D;
  }
`

const Notice = styled.p`
  margin-top: 2rem;
  max-width: 42rem;
  font-family: Sequel45;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #959595;
`
